(function () {
  const logoSlideshow = () => {
    $(".logo-slideshow-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".logo-slideshow");
      const autoplay = box.data("autoplay");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
      const template = box.data("template");

      let sectionClass = $(this)
        .attr("class")
        .search("shopify-section-group-header-group");

      if (sectionClass > 0 && template == "no-index") {
        box.remove();
      } else {
        box.addClass("show");
      }

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = {};
      }
      let swiperParms = {
        parallax: true,
        speed: box.data("speed") * 1000,
        loop: true,
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(`#${id} .logo-slideshow__swiper`, swiperParms);
      colorScheme(swiper);
      swiper.on("beforeTransitionStart", function () {
        colorScheme(this);
      });
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide)
          .find(".logo-slideshow-slide")
          .data("color-scheme");
        changeItems.forEach((item) => {
          $(item)
            .removeClass("color-background-1")
            .removeClass("color-background-4")
            .addClass(colorScheme);
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    logoSlideshow();
    document.addEventListener("shopify:section:load", function () {
      logoSlideshow();
    });
  });
})();
